import React, { Component } from 'react';

import {
  Link
} from 'react-router-dom'

const styles = {
  container: {
    textAlign: 'center',
  }
}

class NotFound extends Component {
  render() {
    return (
      <div style={styles.container}>
        <h1>404 Not Found</h1>
        <Link to='/'>Go to dashboard</Link>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/NotFound/index.js